import {Injectable} from "@angular/core";
import {TranslateService} from "@ngx-translate/core";
import {LoadingController} from "@ionic/angular";

export type UploadType = 'started' | 'ended';
export type CategoryUploadType = 'events' | 'groups' | 'users';

@Injectable({
  providedIn: 'root',
})
export class LoadingAdapter {


  constructor(
    private readonly _loadingController: LoadingController,
    private readonly _translate: TranslateService,
  ) {
  }

  async defaultLoading() {
    const loading = await this._loadingController.create({
      message: this._translate.instant('GENERICS.LABELS.TREATMENT_IN_PROGRESS'),
    });

    await loading.present();
    return loading;
  }

  async defaultError() {
    const loading = await this._loadingController.create({
      message: this._translate.instant('GENERICS.LABELS.DEFAULT_ERROR'),
      duration: 5000
    });

    await loading.present();
    return loading;
  }

  async showMessage(message: string) {
    const loading = await this._loadingController.create({
      message,
      duration: 3000,
    });

    await loading.present();
    return loading;
  }
}
